import styled from "@emotion/styled";
import colors from "styles/colors";
import { BRAND_BLACK_BACKGROUND_COLOR, UI_BORDER_LIGHT_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";

export const StyledProductsTabs = styled.div`
  .mobile-timer-tabs-component {
    gap: 12px;

    .mobile-tabs-title-wrapper {
      margin-bottom: 0;
    }

    .vertical-timer-tab-mobile-component {
      border-radius: 8px;
      padding: 0;
      border: 1px solid;
      border-color: ${colors[UI_BORDER_LIGHT_COLOR_NAME]};
      min-width: fit-content;
      background-color: ${colors[WHITE_COLOR_NAME]};
      color: ${colors[BRAND_BLACK_BACKGROUND_COLOR]};
    }

    .vertical-timer-tab-mobile-title {
      gap: 8px;
      padding: 0;

      .vertical-timer-tab-arrow-wrapper {
        align-self: flex-start;
        padding-right: 12px;
        padding-top: 8px;
      }

      .use-cases {
        flex-wrap: wrap;
      }
    }
  }

  .timer-vertical-tabs-desktop-component {
    margin: 0;
    width: fit-content;

    .tabs-paragraph-wrapper {
      margin-bottom: 0;
      color: ${colors.asphalt};
    }

    .vertical-timer-tabs-container {
      width: fit-content;

      .vertical-timer-tab-arrow-wrapper {
        align-items: flex-start;
        padding-top: 16px;
        padding-right: 16px;
      }

      .desktop-tabs-text-container {
        gap: 12px;
        margin: 0;
        min-height: 0;
        justify-content: flex-start;

        .tab {
          background-color: ${colors[WHITE_COLOR_NAME]};
          box-shadow: 0px 8px 24px 0 rgba(29, 140, 242, 0.16);
          :hover {
            box-shadow: 0px 8px 24px 0 rgba(29, 140, 242, 0.32);
          }
        }

        > :nth-child(2):hover {
          border-color: #6161ff;
        }

        > :nth-child(3):hover {
          border-color: #00d2d2;
        }

        > :nth-child(4):hover {
          border-color: #00c875;
        }

        .tab {
          border-radius: 12px;

          .vertical-timer-tab-desktop-container {
            margin-bottom: 0;
            color: ${colors[BRAND_BLACK_BACKGROUND_COLOR]};
          }

          .vertical-timer-tab-desktop-title-button-selected {
            margin-bottom: 0;
          }

          .vertical-timer-tab-desktop-content {
            margin: 0;
          }
        }
      }
    }
  }
  &.invert-colors {
    .timer-vertical-tabs-desktop-component {
      .vertical-timer-tabs-container {
        .desktop-tabs-text-container {
          .tab {
            background-color: rgba(255, 255, 255, 0.1);
            border: 1px solid;
            border-color: ${colors.asphalt};
            border-radius: 8px;
            box-shadow: unset;
            :hover {
              box-shadow: unset;
            }
            .vertical-timer-tab-desktop-container {
              color: ${colors[WHITE_COLOR_NAME]};
            }
          }
        }
      }
    }
  }
`;
